import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiCheckCircle, FiMail, FiClock } from 'react-icons/fi';
import './AuthPages.css';

const RegistrationCompletePage = () => {
  return (
    <div className="auth-page">
      <div className="auth-container">
        <motion.div
          className="auth-form-section registration-complete"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
        >
          <div className="complete-content">
            <div className="success-icon-large">
              <FiCheckCircle />
            </div>

            <h1>תודה שנרשמת!</h1>

            <div className="complete-message">
              <p className="main-message">
                הפרופיל שלך נשלח לבדיקה
              </p>

              <div className="info-cards">
                <div className="info-card">
                  <FiClock className="info-icon" />
                  <div>
                    <strong>מה עכשיו?</strong>
                    <p>הצוות שלנו יבדוק את הפרופיל שלך בהקדם</p>
                  </div>
                </div>

                <div className="info-card">
                  <FiMail className="info-icon" />
                  <div>
                    <strong>נעדכן אותך במייל</strong>
                    <p>ברגע שהפרופיל יאושר תקבל/י מייל עם קישור להתחברות</p>
                  </div>
                </div>
              </div>
            </div>

            <Link to="/" className="btn btn-primary btn-lg">
              חזרה לדף הבית
            </Link>
          </div>
        </motion.div>

        {/* Right Side - Visual */}
        <motion.div
          className="auth-visual-section"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <div className="visual-content">
            <h2>ברוכים הבאים</h2>
            <h2>למשפחת</h2>
            <h2 className="text-primary">Weon</h2>
            <p>
              בקרוב תוכל/י לגשת לקמפיינים
              בלעדיים מהמותגים המובילים
            </p>
          </div>
          <div className="visual-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
            <div className="shape shape-5"></div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default RegistrationCompletePage;
